module.exports = __webpack_public_path__ + "img/0Q3B1666_Mockup.1ad4d589.jpg";